




import { Component, Prop, Vue } from "vue-property-decorator";

import { ReportTemplate } from "@/models";
import DetailsTable from "./DetailsTable.vue";
import {
  DetailRow,
  DetailSection,
  EMPTY,
  buildCompetitorDetailRows,
} from "./competitorDetailRows";

@Component({ components: { DetailsTable } })
export default class TemplateCompetitorDetailsTable extends Vue {
  @Prop({ required: true }) readonly template!: ReportTemplate;

  displayName(template: ReportTemplate): string {
    return template.name || `Template #${template.id}`;
  }

  profileLabel(profile: ReportTemplate["profile"]): string {
    if (!profile) return EMPTY;
    return profile.slug
      ? `${profile.name} (${profile.slug})`
      : profile.name || EMPTY;
  }

  userLabel(user: ReportTemplate["user"]): string {
    return user?.email || EMPTY;
  }

  get sections(): DetailSection[] {
    const template = this.template;
    const generalRows: DetailRow[] = [
      { label: "Nome", value: this.displayName(template) },
    ];
    if (template.profile) {
      generalRows.push({
        label: "Profilo",
        value: this.profileLabel(template.profile),
      });
    }
    if (template.user) {
      generalRows.push({
        label: "Utente",
        value: this.userLabel(template.user),
      });
    }

    const sections: DetailSection[] = [
      { title: "Informazioni generali", rows: generalRows },
    ];

    if (template.competitor) {
      const rows = buildCompetitorDetailRows(template.competitor);
      if (rows.length) {
        sections.push({ title: "Configurazione", rows });
      }
    }

    return sections;
  }
}
